(() => {
  'use strict';

  if (window.__SKW_INTENT_LABELS__) return;
  window.__SKW_INTENT_LABELS__ = true;

  const LABELS = {
    fast: 'Kaufbereit',
    select: 'Gezielte Produktauswahl',
    compare: 'Produktvergleich',
    browse: 'Inspiration & Orientierung',
    friction: 'Kaufentscheidung stockt',
  };

  const VERSION = '3';
  const META_KEY = 'skw_intent_meta_v3';
  const SNAPSHOT_KEY = 'skw_order_intent_snapshot_v1';
  const CUSTOMER_TAG_PREFIX = 'SKW Erstbestellung: ';

  const ATTR = {
    entryType: 'SKW Einstiegsart',
    entryTarget: 'SKW Einstiegsziel',
    entrySearch: 'SKW Suchbegriff',
    purchaseState: 'SKW Kaufzustand',
    friction: 'SKW Kaufhürde',
    firstOrderTag: 'SKW Erstbestellung Tag',
    version: 'SKW Intent-Version',
    legacyState: 'SKW Kundenzustand',
  };

  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('de-DE')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const safeRead = (key, fallback = null) => {
    try {
      return JSON.parse(window.sessionStorage.getItem(key) || 'null') || fallback;
    } catch (_) {
      return fallback;
    }
  };

  const safeWrite = (key, value) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (_) {}
  };

  const getMode = () => {
    try {
      return window.SKWIntent?.getMode?.() || document.documentElement.dataset.skwIntent || 'select';
    } catch (_) {
      return document.documentElement.dataset.skwIntent || 'select';
    }
  };

  const getLabel = () => LABELS[getMode()] || LABELS.select;
  const getFirstOrderTag = () => `${CUSTOMER_TAG_PREFIX}${getLabel()}`;

  const pageKind = () => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/products/')) return 'Produkt';
    if (path.includes('/collections/')) return 'Collection';
    if (path.includes('/search')) return 'Suche';
    if (path.includes('/blogs/')) return 'Blog/Thema';
    if (path.includes('/pages/')) return 'Landingpage';
    if (path.includes('/cart')) return 'Warenkorb';
    if (path === '/' || /^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(path)) return 'Startseite';
    return 'Sonstige Seite';
  };

  const externalReferrerHost = () => {
    if (!document.referrer) return '';
    try {
      const url = new URL(document.referrer);
      if (url.origin === window.location.origin) return '';
      return url.hostname.replace(/^www\./, '').toLowerCase();
    } catch (_) {
      return '';
    }
  };

  const detectEntryType = () => {
    const host = externalReferrerHost();
    const path = window.location.pathname.toLowerCase();
    const kind = pageKind();

    if (host) {
      if (/(^|\.)google\.|bing\.|ecosia\.|duckduckgo\.|yahoo\./.test(host)) return 'Google/Suchmaschine';
      if (/instagram\.|facebook\.|fb\.|threads\.|pinterest\.|tiktok\.|youtube\.|linkedin\.|bsky\.|flipboard\./.test(host)) return 'Social Media';
      return 'Externe Empfehlung';
    }

    if (path.includes('/search')) return 'Shop-Suche';
    if (kind === 'Produkt') return 'Direktes Produkt';
    if (kind === 'Collection') return 'Collection';
    if (kind === 'Blog/Thema' || kind === 'Landingpage') return 'Blog/Thema';
    if (kind === 'Startseite') return 'Startseite/Direkt';
    return 'Direkter Einstieg';
  };

  const detectEntryTarget = () => {
    const kind = pageKind();
    const path = `${window.location.pathname}${window.location.search}`;
    return `${kind}: ${path}`.slice(0, 180);
  };

  const firstSearchTerm = () => {
    const current = new URLSearchParams(window.location.search).get('q');
    return String(current || '').trim().slice(0, 120);
  };

  const defaultMeta = () => ({
    version: VERSION,
    entryType: detectEntryType(),
    entryTarget: detectEntryTarget(),
    firstSearch: firstSearchTerm(),
    concernSignals: [],
    frictionReasons: [],
    lastReason: '',
  });

  let meta = safeRead(META_KEY, null) || defaultMeta();
  if (!meta.version || meta.version !== VERSION) meta = { ...defaultMeta(), ...meta, version: VERSION };
  if (!meta.firstSearch && firstSearchTerm()) meta.firstSearch = firstSearchTerm();
  safeWrite(META_KEY, meta);

  let snapshot = safeRead(SNAPSHOT_KEY, null);
  let lastPublished = '';
  let syncTimer = null;

  const uniquePush = (list, value, limit = 8) => {
    if (!value) return Array.isArray(list) ? list : [];
    const next = (Array.isArray(list) ? list : []).filter((item) => item !== value);
    next.push(value);
    return next.slice(-limit);
  };

  const mapReason = (reason) => {
    const key = String(reason || '');
    const labels = {
      checkout_return: 'Checkout-Rückkehr',
      cart_removal: 'Artikel aus Warenkorb entfernt',
      repeated_cart_change: 'Warenkorb mehrfach geändert',
      quantity_decrease: 'Menge reduziert',
      product_comparison: 'Produktvergleich',
      multiple_searches_without_decision: 'Mehrere Suchen ohne Entscheidung',
      shipping_or_payment_info: 'Versand/Zahlung geprüft',
      reviews_opened: 'Bewertungen geprüft',
      product_revisit: 'Produkt erneut geprüft',
    };
    return labels[key] || '';
  };

  const rememberReason = (reason) => {
    const readable = mapReason(reason);
    if (!readable) return;
    meta.lastReason = readable;
    meta.concernSignals = uniquePush(meta.concernSignals, readable);
    if (['Checkout-Rückkehr', 'Artikel aus Warenkorb entfernt', 'Warenkorb mehrfach geändert', 'Menge reduziert'].includes(readable)) {
      meta.frictionReasons = uniquePush(meta.frictionReasons, readable);
    }
    safeWrite(META_KEY, meta);
  };

  const currentFriction = () => {
    if (meta.frictionReasons?.length) return meta.frictionReasons[meta.frictionReasons.length - 1];
    if (getMode() === 'friction' && meta.lastReason) return meta.lastReason;
    if (getMode() === 'compare') return 'Produktvergleich';
    return '';
  };

  const publishReadableState = () => {
    const mode = getMode();
    const label = LABELS[mode] || LABELS.select;
    document.documentElement.dataset.skwIntentLabel = label;

    if (window.SKWIntent) {
      window.SKWIntent.getLabel = getLabel;
      window.SKWIntent.getFirstOrderTag = getFirstOrderTag;
    }

    const signature = `${mode}|${label}|${meta.entryType}|${meta.lastReason}`;
    if (signature === lastPublished) return;
    lastPublished = signature;

    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'skw_intent_label', label);
        window.clarity('set', 'skw_entry_type', meta.entryType);
        if (meta.lastReason) window.clarity('set', 'skw_intent_reason_readable', meta.lastReason);
      }
    } catch (_) {}

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'skw_intent_label',
      skw_intent_mode: mode,
      skw_intent_label: label,
      skw_entry_type: meta.entryType,
      skw_entry_target: meta.entryTarget,
      skw_intent_reason_readable: meta.lastReason || '',
    });
  };

  const cartUpdate = async (attributes) => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await window.fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes }),
      });
      return response.ok;
    } catch (_) {
      return false;
    }
  };

  const syncEntryAttributes = async () => cartUpdate({
    [ATTR.entryType]: meta.entryType,
    [ATTR.entryTarget]: meta.entryTarget,
    [ATTR.entrySearch]: meta.firstSearch || '',
    [ATTR.version]: VERSION,
    [ATTR.legacyState]: '',
  });

  const freezeForCheckout = async () => {
    const mode = getMode();
    const label = LABELS[mode] || LABELS.select;
    const friction = currentFriction();
    snapshot = {
      frozen: true,
      at: Date.now(),
      mode,
      label,
      entryType: meta.entryType,
      entryTarget: meta.entryTarget,
      firstSearch: meta.firstSearch || '',
      friction,
      firstOrderTag: `${CUSTOMER_TAG_PREFIX}${label}`,
    };
    safeWrite(SNAPSHOT_KEY, snapshot);

    await cartUpdate({
      [ATTR.entryType]: snapshot.entryType,
      [ATTR.entryTarget]: snapshot.entryTarget,
      [ATTR.entrySearch]: snapshot.firstSearch,
      [ATTR.purchaseState]: snapshot.label,
      [ATTR.friction]: snapshot.friction,
      [ATTR.firstOrderTag]: snapshot.firstOrderTag,
      [ATTR.version]: VERSION,
      [ATTR.legacyState]: '',
    });
  };

  const releaseCheckoutSnapshot = async () => {
    snapshot = null;
    try { window.sessionStorage.removeItem(SNAPSHOT_KEY); } catch (_) {}
    await cartUpdate({
      [ATTR.purchaseState]: '',
      [ATTR.friction]: '',
      [ATTR.firstOrderTag]: '',
      [ATTR.version]: VERSION,
      [ATTR.legacyState]: '',
    });
  };

  const scheduleEntrySync = (delay = 150) => {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncEntryAttributes, delay);
  };

  window.addEventListener('skw:intentchange', (event) => {
    const reason = String(event.detail?.reason || '');
    rememberReason(reason);
    publishReadableState();

    if (reason === 'checkout_return') {
      releaseCheckoutSnapshot();
      return;
    }
    if (reason === 'checkout_start') {
      freezeForCheckout();
      return;
    }
    if (reason === 'add_to_cart') {
      syncEntryAttributes();
      return;
    }
    scheduleEntrySync();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = String(form.getAttribute('action') || '').toLowerCase();
    const isCheckout = event.submitter?.name === 'checkout' || action.includes('/checkout');
    if (isCheckout) freezeForCheckout();
  }, true);

  document.addEventListener('click', (event) => {
    const element = event.target instanceof Element ? event.target : null;
    const target = element?.closest('a, button, input, [role="button"]');
    if (!target) return;
    const href = String(target.getAttribute('href') || '').toLowerCase();
    const name = String(target.getAttribute('name') || '').toLowerCase();
    const text = normalize(target.textContent || target.getAttribute('value') || target.getAttribute('aria-label'));
    if (href.includes('/checkout') || name === 'checkout' || text.includes('zur kasse') || text.includes('checkout') || text.includes('afrekenen')) {
      freezeForCheckout();
    }
  }, true);

  window.SKWIntentLabels = {
    labels: { ...LABELS },
    getLabel,
    getFirstOrderTag,
    getEntry: () => ({ ...meta }),
    getSnapshot: () => snapshot ? { ...snapshot } : null,
    syncEntry: syncEntryAttributes,
    freezeForCheckout,
    releaseCheckoutSnapshot,
  };

  publishReadableState();
  syncEntryAttributes();
})();
